import "../AdminEditableDetailsSection.scss";
import { Payment } from "../../../../Models/Payment";
import { useRef, useState } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "../AdminEditableDetailsSection.scss";
import SnackBar, { SnackTypes } from "../../../UtilityComponents/SnackBar/SnackBar";

interface ManagePaymentsByIdProps {
    payment: Payment;
}

const AdminPaymentEditableDetailsSection: React.FC<ManagePaymentsByIdProps> = ({ payment }) => {

    // Snackbar based status handling 
    const snackBarRef = useRef<{ showSnackbar(): any }>(null)
    const [snackBarParams, setSnackBarParams] = useState({
        message: "",
        state: SnackTypes.error
    });

    const showSnackbar = (message: string, state: SnackTypes) => {
        setSnackBarParams({ message: message, state: state })
        snackBarRef.current?.showSnackbar()
    }

    // Handle copy to clipboard
    const handleCopyToClipboard = async (text: string | number | undefined | null) => {
        try {
            if (text) {
                await navigator.clipboard.writeText(text.toString());
                showSnackbar("Copied to clipboard!", SnackTypes.success);
            } else {
                throw new Error("Null data found.")
            }
        } catch (error) {
            showSnackbar("Failed to copy!", SnackTypes.error);
        }
    };

    return (
        <div className="admin-editable-details-section">
            <SnackBar ref={snackBarRef} severity={snackBarParams.state} alertDuration={5000} message={snackBarParams.message} />

            <Accordion key={payment.id}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className="order-summary">
                    <div className="order-title">
                        <Typography variant="subtitle1"> paymentId - <b>{payment.id}</b></Typography>
                        <Typography variant="subtitle1"> PaymentStatus - <b>{payment.status}</b></Typography>

                    </div>

                    {/* <Box
                        className="edit-btn"
                    >
                        Edit payment
                        <Switch color="success" onClick={(event) => toggleEditMode(event)} />

                    </Box> */}
                </AccordionSummary>
                <AccordionDetails>
                    <div className="order-details">
                        {/* Order Meta Data */}
                        <div className="section">

                            <h3>Order Info -</h3>
                            <br></br>
                            <p onClick={() => handleCopyToClipboard(payment.id)}>
                                <strong>Payment Id:</strong> {payment.id}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.status)}>
                                <strong>Payment Status:</strong> {payment.status}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.amount)}>
                                <strong>Payment Amount:</strong> {payment.amount}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.paymentProvider)}>
                                <strong>Payment Provider:</strong> {payment.paymentProvider}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.transactionId)}>
                                <strong>Payment TxnId (Manual):</strong> {payment.transactionId}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.acquirerData?.bankTransactionId)}>
                                <strong>Payment TxnId (by provider):</strong> {payment.acquirerData?.bankTransactionId}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.entity)}>
                                <strong>Entity:</strong> {payment.entity}
                            </p>
                           
                            <p onClick={() => handleCopyToClipboard(payment.currency)}>
                                <strong>Currency:</strong> {payment.currency}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.orderId)}>
                                <strong>Order Id:</strong> {payment.orderId}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.invoiceId)}>
                                <strong>Invoice Id:</strong> {payment.invoiceId}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.international?.toString())}>
                                <strong>International:</strong> {payment.international?.toString()}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.method)}>
                                <strong>Method:</strong> {payment.method}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.amountRefunded)}>
                                <strong>Amount Refunded:</strong> {payment.amountRefunded}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.refundStatus)}>
                                <strong>Refund Status:</strong> {payment.refundStatus}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.captured?.toString())}>
                                <strong>Captured:</strong> {payment.captured?.toString()}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.description)}>
                                <strong>Description:</strong> {payment.description}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.cardId)}>
                                <strong>Card Id:</strong> {payment.cardId}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.bank)}>
                                <strong>Bank:</strong> {payment.bank}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.wallet)}>
                                <strong>Wallet:</strong> {payment.wallet}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.vpa)}>
                                <strong>VPA:</strong> {payment.vpa}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.email)}>
                                <strong>Email:</strong> {payment.email}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.contact)}>
                                <strong>Contact:</strong> {payment.contact}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.notes?.join(", "))}>
                                <strong>Notes:</strong> {payment.notes && payment.notes.length >= 1 && payment.notes?.join(", ")}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.fee)}>
                                <strong>Fee:</strong> {payment.fee}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.tax)}>
                                <strong>Tax:</strong> {payment.tax}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.errorCode)}>
                                <strong>Error Code:</strong> {payment.errorCode}
                            </p>

                            <p onClick={() => handleCopyToClipboard(payment.errorDescription)}>
                                <strong>Error Description:</strong> {payment.errorDescription}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.errorSource)}>
                                <strong>Error Source:</strong> {payment.errorSource}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.errorStep)}>
                                <strong>Error Step:</strong> {payment.errorStep}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.errorReason)}>
                                <strong>Error Reason:</strong> {payment.errorReason}
                            </p>
                            <p onClick={() => handleCopyToClipboard(payment.paymentProvider)}>
                                <strong>Payment Provider:</strong> {payment.paymentProvider}
                            </p>

                            <p onClick={() => handleCopyToClipboard(payment.createdAt)}>
                                <strong>Created At:</strong> {payment.createdAt}
                            </p>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    )
};

export default AdminPaymentEditableDetailsSection;
